import { render, staticRenderFns } from "./org.vue?vue&type=template&id=227d6ebc&scoped=true"
import script from "./org.vue?vue&type=script&lang=js"
export * from "./org.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227d6ebc",
  null
  
)

export default component.exports